<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
    <path
      d="M12.2499 10.0001C12.6641 10.0001 12.9999 10.3359 12.9999 10.7501C12.9998 11.1643 12.6641 11.5001 12.2499 11.5001H3.74989C3.33575 11.5001 2.99995 11.1643 2.99989 10.7501C2.99989 10.3359 3.33571 10.0002 3.74989 10.0001H12.2499Z"
      fill="#FF4D6A"
    />
    <path
      d="M10.7499 7.50013C11.1641 7.50013 11.4999 7.83592 11.4999 8.25013C11.4998 8.66429 11.1641 9.00013 10.7499 9.00013H5.24989C4.83575 9.00009 4.49995 8.66427 4.49989 8.25013C4.49989 7.83595 4.83571 7.50018 5.24989 7.50013L10.7499 7.50013Z"
      fill="#FF4D6A"
    />
    <path
      d="M9.24989 5.00013C9.6641 5.00013 9.99989 5.33592 9.99989 5.75013C9.99983 6.16429 9.66407 6.50013 9.24989 6.50013L6.74989 6.50013C6.33575 6.50009 5.99995 6.16427 5.99989 5.75013C5.99989 5.33595 6.33571 5.00018 6.74989 5.00013L9.24989 5.00013Z"
      fill="#FF4D6A"
    />
    <path
      d="M7.99989 2.50013C8.4141 2.50013 8.74989 2.83592 8.74989 3.25013C8.74983 3.66429 8.41407 4.00013 7.99989 4.00013C7.58575 4.00009 7.24995 3.66427 7.24989 3.25013C7.24989 2.83594 7.58571 2.50018 7.99989 2.50013Z"
      fill="#FF4D6A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.82948 1.79115C6.78922 0.11161 9.21057 0.11161 10.1703 1.79115L14.724 9.7599C15.6763 11.4265 14.4731 13.5001 12.5536 13.5001H3.44618C1.52676 13.5 0.323585 11.4265 1.27577 9.7599L5.82948 1.79115ZM9.30214 2.28724C8.72629 1.27952 7.27349 1.27952 6.69764 2.28724L2.14393 10.256C1.5727 11.2559 2.29459 12.5 3.44618 12.5001H12.5536C13.7053 12.5001 14.4272 11.2559 13.8558 10.256L9.30214 2.28724Z"
      fill="#FF4D6A"
    />
  </svg>
</template>
